module.exports = __webpack_public_path__ + "static/media/Introduction_modern.51aaff74.png";